/**
 * Sizing links. Any link to one of these opens the matching thing on the product page:
 *   #size-guide   -> the product's Size guide popup (the AERIS size chart, or a popup-link
 *                    block whose label mentions "size")
 *   #find-my-size -> the Find my size fit quiz, if the page has one
 * Works from rich text in the theme editor, and as a full URL from anywhere else:
 * /products/<handle>#size-guide opens the page with it showing.
 */
(() => {
  const OPENERS = {
    '#size-guide': () =>
      document.querySelector('.aeris-sc-inline') ||
      document.querySelector('.aeris-sc-trigger') ||
      [...document.querySelectorAll('.popup-link__button')].find((button) => /size/i.test(button.textContent)),
    '#find-my-size': () => document.querySelector('aeris-fit-quiz [data-open], cyn-fit-quiz [data-open]'),
  };

  const open = (hash) => {
    const button = OPENERS[hash]?.();
    if (!button) return false;
    button.click();
    return true;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const url = new URL(link.getAttribute('href'), location.href);
    if (!OPENERS[url.hash]) return;
    // Only intercept links to this page; a link to another product navigates normally.
    if (url.origin !== location.origin || url.pathname !== location.pathname) return;
    if (open(url.hash)) event.preventDefault();
  });

  // The address changed to one of the hashes on an open page (Back button, typed URL).
  window.addEventListener('hashchange', () => OPENERS[location.hash] && open(location.hash));

  // Arrived with one of the hashes in the address: open once the page is ready.
  if (OPENERS[location.hash]) {
    const hash = location.hash;
    const tryOpen = (attempt = 0) => {
      if (open(hash)) return;
      if (attempt < 20) setTimeout(() => tryOpen(attempt + 1), 150);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => tryOpen());
    else tryOpen();
  }
})();
